"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _Button = _interopRequireDefault(require("../Button"));
var _utils = require("../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; } /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
var slideoutTransition = function slideoutTransition(Component) {
  var SlideoutWrapper = function SlideoutWrapper(props) {
    var isMounted = props.isMounted,
      slideDuration = props.slideDuration;
    var _useState = (0, _react.useState)(isMounted),
      _useState2 = _slicedToArray(_useState, 2),
      shouldRender = _useState2[0],
      setShouldRender = _useState2[1];
    var currentTimeout = undefined;
    (0, _react.useEffect)(function () {
      if (isMounted === false) {
        // This timeout is to give the slideout enough time for it to transition off the page before it is unmounted
        currentTimeout = setTimeout(function () {
          return shouldRender && setShouldRender(false);
        }, slideDuration);
      } else if (isMounted === true) {
        currentTimeout && clearTimeout(currentTimeout);
        !shouldRender && setShouldRender(true);
      }
      return function () {
        return currentTimeout && clearTimeout(currentTimeout);
      };
    }, [isMounted]);
    return shouldRender ? /*#__PURE__*/_react.default.createElement(Component, props) : null;
  };
  return SlideoutWrapper;
};
var Slideout = function Slideout(_ref) {
  var width = _ref.width,
    widthUnits = _ref.widthUnits,
    from = _ref.from,
    slideDuration = _ref.slideDuration,
    offset = _ref.offset,
    isMounted = _ref.isMounted,
    children = _ref.children,
    overlay = _ref.overlay,
    onOverlayClick = _ref.onOverlayClick,
    className = _ref.className;
  var widthValue = "".concat(width).concat(widthUnits !== null && widthUnits !== void 0 ? widthUnits : 'px');
  var offsetValue = "".concat(offset !== null && offset !== void 0 ? offset : 0, "px");
  var _useState3 = (0, _react.useState)(_defineProperty({
      width: widthValue,
      transition: "".concat(slideDuration / 1000, "s")
    }, from, "-".concat(widthValue))),
    _useState4 = _slicedToArray(_useState3, 2),
    slideoutCSS = _useState4[0],
    setSlideoutCSS = _useState4[1];
  var slideoutRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var _slideoutRef$current;
    isMounted && ((_slideoutRef$current = slideoutRef.current) === null || _slideoutRef$current === void 0 ? void 0 : _slideoutRef$current.focus());
    setSlideoutCSS(_objectSpread(_objectSpread({}, slideoutCSS), {}, _defineProperty({}, from, isMounted ? offsetValue : "-".concat(widthValue))));
  }, [isMounted]);
  var onKeypress = function onKeypress(event) {
    slideoutRef.current && isMounted && (0, _utils.trapBrowserFocusToElement)(event, slideoutRef.current);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames2.default)(_defineProperty({
      'sa-slideout-wrapper': true
    }, className, !!className)),
    ref: slideoutRef
    // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
    ,
    tabIndex: isMounted ? 0 : -1,
    "aria-label": "Slide out component",
    onKeyDown: onKeypress,
    role: "dialog"
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: slideoutCSS,
    "data-testid": "sa-slideout",
    className: "sa-slideout"
  }, isMounted && children ? children : null), overlay && isMounted && /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: "button",
    className: "sa-slideout-overlay",
    onClick: onOverlayClick,
    style: _defineProperty({}, from, offsetValue),
    title: "Close slide out"
  }));
};
var _default = slideoutTransition(Slideout);
exports.default = _default;